export function capitalizeFirstLetter(param: string) {
  return param.charAt(0).toUpperCase() + param.slice(1);
}
